import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from 'yup';

import {AuthLayout} from "../../components/auth";
import {FullLogo} from "../../components/icons";
import {Button, Input} from "../../components/common";
import {ALERT_TYPES, BUTTON_TYPES, INPUT_PLACEHOLDERS, INPUT_TYPES, ROUTES} from "../../types";
import {useMutation} from "react-query";
import {useAlert} from "../../components/common/Alert";
import {phoneRegex} from "../../utils/regex";

interface ISchema {
  [key: string]: string;
  email: string;
  login: string;
  name: string;
  password: string;
  phone_number: string;
}

const SignUp = () => {
  const { setAlert } = useAlert()
  const navigate = useNavigate()

  const validationSchema: Yup.Schema<ISchema> = Yup.object().shape({
    name: Yup.string().required('ФИО не может быть пустым'),
    login: Yup.string().required('Логин не может быть пустым'),
    email: Yup.string()?.email('Невалидный email').required('Email не может быть пустым'),
    password: Yup.string().required('Пароль не может быть пустым'),
    phone_number: Yup.string().required('Поле не может быть пустым')
      ?.matches(phoneRegex, `Номер должнен быть в формате ${INPUT_PLACEHOLDERS.PHONE}`),
  });

  const userSignUp = useMutation(["signUp"], {
    onMutate: (data: { username: string; fio: string; email: string; password: string; phone_number: string }) => {},
    onSuccess: () => {
      setAlert('Вы успешно зарегистрированы! Подтвердите вашу почту, письмо было отправлено!', ALERT_TYPES.SUCCESS);
      navigate(ROUTES.SIGN_IN);
    },
    onError: (e: any) => {
      const errorText: string = `${Object.values(e.response.data).flat(2)?.[0]}`;
      setAlert(errorText, ALERT_TYPES.ERROR);
    }
  })

  const submitForm = async (values: any) => {
    const { name, login, email, password, phone_number } = values;
    await userSignUp.mutate({
      username: login,
      fio: name,
      email,
      password,
      phone_number
    })
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      login: '',
      email: '',
      password: '',
      phone_number: ''
    },
    validationSchema: validationSchema,
    onSubmit: submitForm
  });

  const {
    errors, touched
  } = formik;

  const handleSubmit = () => formik.handleSubmit();

  return (
    <AuthLayout isSignUp={true}>
      <FullLogo className="mx-auto" />
      <div className="mt-6">
        <p className="text-[14px] leading-[24px] font-medium text-black mb-1">ФИО</p>
        <Input
          className="w-full"
          id="name"
          name="name"
          placeholder="Введите ФИО"
          onChange={formik.handleChange}
          error={touched?.name ? errors?.name : false}
        />

        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Логин</p>
        <Input
          className="w-full"
          id="login"
          name="login"
          placeholder="Введите логин"
          onChange={formik.handleChange}
          error={touched?.login ? errors?.login : false}
        />

        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Номер телефона</p>
        <Input
          className="w-full"
          id="phone_number"
          name="phone_number"
          placeholder={INPUT_PLACEHOLDERS.PHONE}
          onChange={formik.handleChange}
          error={touched?.phone_number ? errors?.phone_number : false}
        />

        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Адрес электронной почты</p>
        <Input
          className="w-full"
          id="email"
          name="email"
          type={INPUT_TYPES.EMAIL}
          placeholder="Введите email"
          onChange={formik.handleChange}
          error={touched?.email ? errors?.email : false}
        />

        <p className="text-[14px] leading-[24px] font-medium text-black mt-4">Пароль</p>
        <Input
          className="w-full"
          id="password"
          name="password"
          type={INPUT_TYPES.PASSWORD}
          placeholder="Введите пароль"
          onChange={formik.handleChange}
          error={touched?.password ? errors?.password : false}
        />

        <Button
          title={'Регистрация'}
          onClick={handleSubmit}
          className="w-full mt-4"
        />

        {/*<Button*/}
        {/*  title={'Войти через Google'}*/}
        {/*  onClick={handleSubmit}*/}
        {/*  type={BUTTON_TYPES.GOOGLE}*/}
        {/*  className="w-full mt-1"*/}
        {/*/>*/}

        <div className="flex items-center justify-center mt-4">
          <p className="text-mainBlack/75 text-[12px] leading-[14px]">Уже есть аккаунт?</p>
          <Link to={ROUTES.SIGN_IN} className="ml-1 text-primary text-[12px] leading-[14px] underline cursor:pointer">Войти</Link>
        </div>
      </div>
    </AuthLayout>
  )
};

export default SignUp;
